import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Icon from 'builder/components/Icon'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Container = styled.div`
  background-color: ${Colors.White};
  width: 100%;

  border-radius: ${Spacing.S};
  display: inline-flex;
  padding: 8px 12px;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${Colors.Blue10};
  }

  &:active {
    background-color: ${Colors.Blue20};
  }

  ${Media.Phone`
    width: 100%;
    justify-content: space-between;
    background-color: ${Colors.Neutral10};
  `};
`

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ActionTitle = styled.p`
  color: ${Colors.Neutral90};
  ${Typography.Caption};
  ${FontWeights.Medium}
  transition: color 0.2s ease-in-out;

  ${Container}:hover & {
    color: ${Colors.Blue80};
  }

  ${Container}:active & {
    color: ${Colors.Blue90};
  }
  ${Media.Phone`
    color: ${Colors.Neutral90};
  `};
`

export const ActionDescription = styled.p`
  color: ${Colors.Neutral50};
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.3px;
  ${FontWeights.Regular};
  transition: color 0.2s ease-in-out;

  ${Container}:hover & {
    color: ${Colors.Blue80};
  }

  ${Container}:active & {
    color: ${Colors.Blue90};
  }
  ${Media.Phone`
    color: ${Colors.Neutral50};
  `};
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 8px;
  background: ${Colors.Neutral10};
  transition: background-color 0.2s ease-in-out;

  ${Container}:hover & {
    background: ${Colors.Blue20};
  }

  ${Container}:active & {
    background: ${Colors.Blue20};
  }

  ${Media.Phone`
    background: ${Colors.Neutral20};
  `};
`
export const ActionIcon = styled(Icon.ArrowRight)`
  color: ${Colors.Neutral70};
  transition: color 0.2s ease-in-out;

  ${Container}:hover & {
    color: ${Colors.Blue80};
  }

  ${Container}:active & {
    color: ${Colors.Blue90};
  }

  ${Media.Phone`
    color: ${Colors.Neutral70};
  `};
`
